import { ShapeProps } from '@features/powerpoint';
import { colorByIndex } from '../audience-profile/color-by-index';
import { DemographicProfileChartConfiguration } from '../demographic-profile';

const CHART_BACKGROUND_BLUE = '#8FAADC';
const CHART_BACKGROUND_GREEN = '#548235';

const chartBoxProps = [
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_BLUE,
        transparency: 70,
      },
      h: 1.96,
      w: 2.83,
      x: 0.76,
      y: 1.83,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_GREEN,
        transparency: 65,
      },
      h: 1.96,
      w: 2.83,
      x: 3.8,
      y: 1.83,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_BLUE,
        transparency: 84,
      },
      h: 1.96,
      w: 2.83,
      x: 6.81,
      y: 1.83,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_GREEN,
        transparency: 65,
      },
      h: 1.96,
      w: 2.83,
      x: 9.83,
      y: 1.83,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_BLUE,
        transparency: 70,
      },
      h: 1.96,
      w: 2.83,
      x: 0.76,
      y: 3.95,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_GREEN,
        transparency: 65,
      },
      h: 1.96,
      w: 2.83,
      x: 3.8,
      y: 3.95,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_BLUE,
        transparency: 84,
      },
      h: 1.96,
      w: 2.83,
      x: 6.81,
      y: 3.95,
    },
  },
  {
    shapeName: 'rect',
    options: {
      fill: {
        color: CHART_BACKGROUND_GREEN,
        transparency: 65,
      },
      h: 1.96,
      w: 2.83,
      x: 9.83,
      y: 3.95,
    },
  },
] as const satisfies readonly ShapeProps[];

type ShapesOptions = {
  chartConfig: DemographicProfileChartConfiguration;
};

export const shapes = (options: ShapesOptions): ShapeProps[] =>
  options.chartConfig.map((_, chartIndex): ShapeProps => {
    const shapeProps = chartBoxProps[chartIndex];

    return {
      shapeName: shapeProps.shapeName,
      options: {
        ...shapeProps.options,
        x: shapeProps.options.x,
        fill: {
          transparency: shapeProps.options.fill.transparency,
          color: shapeProps.options.fill.color ?? colorByIndex(chartIndex),
        },
      },
    };
  });
